<template>
	<!-- TODO 划线价 -->
	<span class="container" :class="isCrossedPrice ? 'cross-price' : ''" :style="{ '--font-color': color, '--label-size': labelSize, '--unit-size': unitSize }">
		<span v-if="type == '0'"><span class="unit">￥</span><span class="number">{{ number }}</span></span>
		<span v-else><span class="number">{{ number }}</span><span class="unit zhe">折</span></span>
	</span>
</template>

<script>
export default {
	name: "NumberStyle",
	props: {
		// "type": "0", //礼券类型（0：满减，1：折扣）
		type: {
			type: [String, Number],
			default: "0",
		},
		number: {
			type: [Number, String],
			default: 0,
		},
		labelSize: {
			type: [Number, String],
			default: 36,
		},
		unitSize: {
			type: [Number, String],
			default: 20,
		},
		color: {
			type: String,
			default: "#f73c3c",
		},
		isCrossedPrice: {
			type: Boolean,
			default: false,
		},
	},
};
</script>

<style scoped lang="less">
.container {
	font-size: 0;
	@label-size: calc(var(--label-size) * 1px);
	@unit-size: calc(var(--unit-size) * 1px);
	.number{
		font-family: DINAlternate-Bold;
	}
	span {
		font-size: @label-size;
		font-weight: 550;
		color: var(--font-color);
		.unit {
			font-size: @unit-size;
		}
		.zhe {
			margin-left: 4px;
		}
	}
	&.cross-price {
		text-decoration: line-through;
		color: #BEBEBE;
		span{
			color: #BEBEBE;
		}
	}
}
</style>
